import { useRef } from 'react';

import { useAppDispatch } from 'src/redux_store';
import { uploadImage } from 'src/redux_store/post/post_action';
import { addIdImage } from 'src/redux_store/post/post_slice';
import SunEditor from 'suneditor-react';
import { UploadBeforeHandler } from 'suneditor-react/dist/types/upload';
import 'suneditor/dist/css/suneditor.min.css';
import {
  align,
  blockquote,
  font,
  fontColor,
  fontSize,
  formatBlock,
  hiliteColor,
  horizontalRule,
  image,
  lineHeight,
  link,
  list,
  paragraphStyle,
  table,
  template,
  textStyle,
} from 'suneditor/src/plugins';

interface IProps {
  body: string;
  height: number;
  handleChangeBody: (value: string) => void;
}

const FormEditor = ({ body, handleChangeBody, height }: IProps) => {
  const dispatch = useAppDispatch();

  const editor = useRef();

  const handleChange = (content: string) => {
    handleChangeBody(content);
  };

  // const handleImageUploadError = (errorMessage: any, result: any) => {
  //   console.log('2', errorMessage, result);
  // };

  // const handleImageUpload = (
  //   targetImgElement: any,
  //   index: any,
  //   state: any,
  //   imageInfo: any,
  //   remainingFilesCount: any,
  // ) => {
  //   console.log('3', targetImgElement, index, state, imageInfo, remainingFilesCount);
  // };

  const getSunEditorInstance = (sunEditor: any) => {
    editor.current = sunEditor;
  };

  const handleImageUploadBefore = (
    files: Array<File>,
    info: object,
    uploadHandler: UploadBeforeHandler,
  ) => {
    const uploadFile = files[0];
    const formData = new FormData();
    formData.append('files', uploadFile);

    dispatch(uploadImage(formData))
      .unwrap()

      .then((data) => {
        if (!data.length) return;
        dispatch(addIdImage(data[0].id));

        uploadHandler({
          result: [{ url: data[0]?.path, name: data[0]?.id, size: 0 }],
        });
      });

    return true;
  };

  return (
    <SunEditor
      onChange={handleChange}
      name="editor_form"
      setContents={body}
      placeholder="Enter your content !!!"
      width="100%"
      height={String(height - 110)}
      getSunEditorInstance={getSunEditorInstance}
      onImageUploadBefore={handleImageUploadBefore}
      // onImageUpload={handleImageUpload}
      // onImageUploadError={handleImageUploadError}
      setOptions={{
        plugins: [
          align,
          font,
          fontColor,
          blockquote,
          fontSize,
          formatBlock,
          hiliteColor,
          horizontalRule,
          lineHeight,
          list,
          paragraphStyle,
          table,
          template,
          textStyle,
          image,
          link,
        ],
        buttonList: [
          ['undo', 'redo'],
          ['font', 'fontSize', 'formatBlock'],
          ['paragraphStyle'],
          ['blockquote'],
          ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
          ['fontColor', 'hiliteColor'],
          ['removeFormat'],
          ['outdent', 'indent'],
          ['align', 'horizontalRule', 'list', 'lineHeight'],
          ['table', 'link', 'image'],
          ['codeView', 'preview', 'print'],
          ['save'],
        ],
        formats: ['p', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
        font: ['Arial', 'Open Sans ', 'Moon Dance', 'Lato', 'Quicksand', 'Roboto'],
      }}
    />
  );
};

export default FormEditor;
